var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit } from "vue-property-decorator";
import { CollectionCaseService } from "~/services/domain-service/collection-case.service";
import { HistoryCasesService } from "~/services/business-service/history-cases.service";
var DelCaseBatchNumber = /** @class */ (function (_super) {
    __extends(DelCaseBatchNumber, _super);
    function DelCaseBatchNumber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.batchNumberList = [];
        _this.caseissuedFlag = '';
        _this.model = {
            batchNumber: ""
        };
        _this.loading = {
            state: false
        };
        _this.rules = {
            batchNumber: [{ required: true, message: "请选择批次号", trigger: "blur" }]
        };
        return _this;
    }
    DelCaseBatchNumber.prototype.close = function () {
        var form = this.$refs["form"];
        if (form) {
            form.resetFields();
        }
    };
    DelCaseBatchNumber.prototype.mounted = function () {
        this.refreshData();
    };
    DelCaseBatchNumber.prototype.save = function () {
        var _this = this;
        var form = this.$refs["form"];
        if (form) {
            form.validate(function (valid) {
                if (!valid)
                    return;
                _this.loading.state = true;
                _this.historyCasesService.deleteCases('', _this.model.batchNumber)
                    .subscribe(function (data) {
                    _this.$message.success("批次删除案件成功");
                    _this.close();
                });
            });
        }
    };
    DelCaseBatchNumber.prototype.cancel = function () {
        this.close();
    };
    DelCaseBatchNumber.prototype.refreshData = function () {
        var _this = this;
        this.historyCasesService.getReturnCasesBatchNumber()
            .subscribe(function (data) { return (_this.batchNumberList = data); });
    };
    __decorate([
        Dependencies(CollectionCaseService)
    ], DelCaseBatchNumber.prototype, "collectionCaseService", void 0);
    __decorate([
        Dependencies(HistoryCasesService)
    ], DelCaseBatchNumber.prototype, "historyCasesService", void 0);
    __decorate([
        Emit("close")
    ], DelCaseBatchNumber.prototype, "close", null);
    DelCaseBatchNumber = __decorate([
        Component({
            components: {}
        })
    ], DelCaseBatchNumber);
    return DelCaseBatchNumber;
}(Vue));
export default DelCaseBatchNumber;
